var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('MainSearch',{attrs:{"queryParams":_vm.queryParams,"currentTab":_vm.currentTab,"fullDate":_vm.fullDate}}),_vm._v(" "),_c('MainList',{attrs:{"queryParams":_vm.queryParams,"currentTab":_vm.currentTab,"fullDate":_vm.fullDate,"fieldobj":_vm.fieldobj}})],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e82cf94","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/site/main/component/MainManagementList.vue
// module id = null
// module chunks = 